export const AddCircleIcon = (props) => (
  <svg viewBox="0 0 24 24" {...props} fill={props.color} height={`${props.size || 24}`} width={`${props.size || 24}`}>
    <g>
      <path d="M19.07 4.93A10 10 0 1 0 4.93 19.07 10 10 0 1 0 19.07 4.93zM16.5 13H13v3.5a1 1 0 0 1-2 0V13H7.5a1 1 0 0 1 0-2H11V7.5a1 1 0 0 1 2 0V11h3.5a1 1 0 0 1 0 2z" />
    </g>
  </svg>
);
